(() => {
  const MOBILE_QUERY = '(max-width: 767px)';
  const mediaQuery = window.matchMedia(MOBILE_QUERY);

  const observeOverflow = (block, content, btn) => {
    const observer = new ResizeObserver(() => {
      if (!block.classList.contains('is-expanded')) {
        const isOverflowing =
          content.scrollHeight > content.clientHeight + 1;

        btn.style.display = isOverflowing ? '' : 'none';
      }
    });

    observer.observe(content);
    block._readmoreObserver = observer;
  };

  const initReadMore = () => {
    document.querySelectorAll('[data-readmore]').forEach(block => {
      const content = block.querySelector('[data-readmore-content]');
      const btn = block.querySelector('[data-readmore-toggle]');
      if (!content || !btn) return;

      const btnMoreText = btn.dataset.readmoreMoreText || 'Read more';
      const btnLessText = btn.dataset.readmoreLessText || 'Read less';

      // DESKTOP
      if (!mediaQuery.matches) {
        block.classList.remove('is-expanded');
        btn.style.display = 'none';
        btn.textContent = btnMoreText;

        if (block._readmoreObserver) {
          block._readmoreObserver.disconnect();
          delete block._readmoreObserver;
        }

        return;
      }

      // MOBILE INIT (once)
      if (!block.dataset.readmoreInit) {
        block.dataset.readmoreInit = 'true';

        btn.addEventListener('click', () => {
          const expanded = block.classList.toggle('is-expanded');
          btn.textContent = expanded ? btnLessText : btnMoreText;
        });
      }

      // initial button state
      btn.textContent = block.classList.contains('is-expanded')
        ? btnLessText
        : btnMoreText;

      const isOverflowing =
        content.scrollHeight > content.clientHeight + 1;

      btn.style.display = isOverflowing ? '' : 'none';

      if (!block._readmoreObserver) {
        observeOverflow(block, content, btn);
      }
    });
  };

  mediaQuery.addEventListener('change', initReadMore);
  document.addEventListener('DOMContentLoaded', initReadMore);
  document.addEventListener('shopify:section:load', initReadMore);
})();